// extracted by mini-css-extract-plugin
export default {"download-btn":"DownloadBtn_download-btn__F86ar","btn-label":"DownloadBtn_btn-label__0IUoM","download-icon":"DownloadBtn_download-icon__52gXM"};